import { render, staticRenderFns } from "./BudgetWizardComponent.vue?vue&type=template&id=7cb920ef&"
import script from "./BudgetWizardComponent.vue?vue&type=script&lang=js&"
export * from "./BudgetWizardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports